module.exports = __webpack_public_path__ + "img/waxu.d72e3354.png";